<template>
  <v-tooltip
    :disabled="!tooltip"
    bottom
  >
    <template slot="activator">
      <v-btn
        :to="to"
        :color="color"
        :fab="float"
        :dark="float"
        :flat="!float"
        :icon="!float"
        :small="small"
        :loading="loading"
        :disabled="disabled"
        @click.stop="$emit('click')"
      >
        <div>
          <v-icon>{{ icon }}</v-icon>
        </div>
      </v-btn>
    </template>
    <span>{{ tooltip }}</span>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    /* eslint-disable vue/require-default-prop */
    to: Object | String,
    color: String,
    icon: {
      type: String,
      default: 'fa-exclamation-triangle'
    },
    tooltip: {
      type: String,
      default: ''
    },
    float: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
    /* eslint-enable vue/require-default-prop */
  }
}
</script>
